import * as React from 'react';
import useI18n from 'src/hooks/useI18n';

import {classify} from 'src/utils/classify';

import {EditorState} from 'draft-js';

import {
  Toast,
  TOAST_SEMANTIC,
  toastApi,
  ToastTitle,
} from '@spaced-out/ui-design-system/lib/components/Toast';

import {
  PanelBody,
  PanelFooter,
} from '@spaced-out/ui-design-system/lib/components/Panel';
import {Button} from '@spaced-out/ui-design-system/lib/components/Button';

import EvaluationScorecardEdit from './evaluation-scorecard-edit';
import EvaluationSubjectiveQuestionsEdit from './evaluation-subjective-questions-edit';
import EvaluationRecommendationEdit from './evaluation-recommendation-edit';

import css from './evaluation-form-edit.css';
import {convertDraftToHTML} from 'src/utils/crm-new/common';


export const getTextFromHtml = (html: string) => {
  const span = document.createElement('span');
  span.innerHTML = html;
  return span.textContent || span.innerText;
};

// @ts-expect-error - TS7030 - Not all code paths return a value.
const getInitialValue = (
  review: any,
  scorecardStepSections: any,
  subjectiveSections: any,
) => {
  if (review) {
    const {feedbackScores, answers = [], reviewStatus, comment} = review;

    // @ts-expect-error - TS2347 - Untyped function calls may not accept type arguments.
    const feedbackScoresList = scorecardStepSections.reduce<Array<any>>(
      // @ts-expect-error - TS7006 - Parameter 'acc' implicitly has an 'any' type. | TS7006 - Parameter 'section' implicitly has an 'any' type.
      (acc, section) => {
        // @ts-expect-error - TS7006 - Parameter 'param' implicitly has an 'any' type.
        const parameters = section.parameters.map((param) => {
          const filledParameter = (feedbackScores || []).find(
            // @ts-expect-error - TS7006 - Parameter 'fs' implicitly has an 'any' type.
            (fs) => fs.parameterId === param.id,
          );
          if (filledParameter) {
            return {
              parameterId: param.id,
              score: filledParameter.score,
              remark: filledParameter.remark,
            };
          }
          return {
            parameterId: param.id,
            score: null,
            remark: null,
          };
        });

        return [...acc, ...parameters];
      },
      [],
    );

    // @ts-expect-error - TS2347 - Untyped function calls may not accept type arguments.
    const questions = subjectiveSections.reduce<Array<any>>(
      // @ts-expect-error - TS7006 - Parameter 'acc' implicitly has an 'any' type. | TS7006 - Parameter 'subjectiveSection' implicitly has an 'any' type.
      (acc, subjectiveSection) => {
        return [...acc, ...subjectiveSection.section.questions];
      },
      [],
    );

    return {
      feedbackScores: feedbackScoresList,
      // @ts-expect-error - TS2347 - Untyped function calls may not accept type arguments. | TS7006 - Parameter 'acc' implicitly has an 'any' type. | TS7006 - Parameter 'item' implicitly has an 'any' type.
      answers: answers.reduce<Record<string, any>>((acc, item) => {
        acc[item.questionId] = item.answer;
        return acc;
      }, {}),
      reviewStatus,
      comment,
    };
  }
  if (!review) {
    // @ts-expect-error - TS2347 - Untyped function calls may not accept type arguments.
    const feedbackScores = scorecardStepSections.reduce<Array<any>>(
      // @ts-expect-error - TS7006 - Parameter 'acc' implicitly has an 'any' type. | TS7006 - Parameter 'section' implicitly has an 'any' type.
      (acc, section) => {
        // @ts-expect-error - TS7006 - Parameter 'param' implicitly has an 'any' type.
        const parameters = section.parameters.map((param) => {
          return {
            parameterId: param.id,
            score: null,
            remark: null,
          };
        });

        return [...acc, ...parameters];
      },
      [],
    );

    return {
      feedbackScores,
      answers: {},
      reviewStatus: null,
      comment: '',
    };
  }
};

const EvaluationFormEdit = ({
  // @ts-expect-error - TS7031 - Binding element 'scorecardStepSections' implicitly has an 'any' type.
  scorecardStepSections,
  // @ts-expect-error - TS7031 - Binding element 'subjectiveSections' implicitly has an 'any' type.
  subjectiveSections,
  // @ts-expect-error - TS7031 - Binding element 'feedbackConfiguration' implicitly has an 'any' type.
  feedbackConfiguration,
  // @ts-expect-error - TS7031 - Binding element 'review' implicitly has an 'any' type.
  review,
  // @ts-expect-error - TS7031 - Binding element 'step' implicitly has an 'any' type.
  step,
  // @ts-expect-error - TS7031 - Binding element 'stepCandidateId' implicitly has an 'any' type.
  stepCandidateId,
  // @ts-expect-error - TS7031 - Binding element 'token' implicitly has an 'any' type.
  token,
  // @ts-expect-error - TS7031 - Binding element 'tokenId' implicitly has an 'any' type.
  tokenId,
  // @ts-expect-error - TS7031 - Binding element 'onBehalfOfUserId' implicitly has an 'any' type.
  onBehalfOfUserId,
  // @ts-expect-error - TS7031 - Binding element 'alreadyInPanelBody' implicitly has an 'any' type.
  alreadyInPanelBody,
  //on submit props
  // @ts-expect-error - TS7031 - Binding element 'onSubmit' implicitly has an 'any' type.
  onSubmit,
  // @ts-expect-error - TS7031 - Binding element 'onCancel' implicitly has an 'any' type.
  onCancel,
  // @ts-expect-error - TS7031 - Binding element 'isSubmitting' implicitly has an 'any' type.
  isSubmitting,
}) => {
  const {labelI18nInstance} = useI18n();
  const t = labelI18nInstance.t;

  const questions = subjectiveSections?.reduce(
    (acc: any, subjectiveSection: any) => {
      return [...acc, ...subjectiveSection.section.questions];
    },
    [],
  );

  const [errorQuestionIds, setErrorQuestionIds] = React.useState([]);

  // @ts-expect-error - TS7006 - Parameter 'intermediateEvaluation' implicitly has an 'any' type. | TS7006 - Parameter 'action' implicitly has an 'any' type.
  const reducer = (intermediateEvaluation, action) => {
    if (!intermediateEvaluation) {
      return;
    }
    switch (action.type) {
      case 'SCORECARD_PARAMETER': {
        const {parameterId, score} = action;
        const initialFeedbackScores =
          intermediateEvaluation.feedbackScores || [];
        if (
          !initialFeedbackScores.some(
            // @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
            (item) => item.parameterId === parameterId,
          )
        ) {
          initialFeedbackScores.push({
            parameterId,
            score,
            remark: null,
          });
        }

        const modifiedFeedbackScores = (
          intermediateEvaluation.feedbackScores || initialFeedbackScores
        )
          // @ts-expect-error - TS7006 - Parameter 'feedbackScore' implicitly has an 'any' type.
          .map((feedbackScore) => {
            if (feedbackScore.parameterId === parameterId) {
              return {
                ...feedbackScore,
                score,
              };
            }
            return feedbackScore;
          });
        const values = {
          ...intermediateEvaluation,
          feedbackScores: modifiedFeedbackScores,
        } as const;

        return values;
      }
      case 'SCORECARD_REMARK': {
        const {parameterId, remark} = action;

        const modifiedFeedbackScores =
          // @ts-expect-error - TS7006 - Parameter 'feedbackScore' implicitly has an 'any' type.
          intermediateEvaluation.feedbackScores.map((feedbackScore) => {
            if (feedbackScore.parameterId === parameterId) {
              return {
                ...feedbackScore,
                remark,
              };
            }
            return feedbackScore;
          });

        const values = {
          ...intermediateEvaluation,
          feedbackScores: modifiedFeedbackScores,
        } as const;

        return values;
      }
      case 'SUBJECTIVE_ANSWERS': {
        const {questionId, answer} = action;
        const values = {
          ...intermediateEvaluation,
          answers: {
            ...intermediateEvaluation.answers,
            [questionId]: answer,
          },
        } as const;

        return values;
      }
      case 'OVERALL_STATUS': {
        const {reviewStatus} = action;

        const values = {
          ...intermediateEvaluation,
          reviewStatus,
        } as const;

        return values;
      }
      case 'OVERALL_COMMENT': {
        const {comment} = action;

        const values = {
          ...intermediateEvaluation,
          comment,
        } as const;

        return values;
      }

      case 'RESET_INTERMEDIATE_EVALUATION': {
        const values = getInitialValue(
          review,
          scorecardStepSections,
          subjectiveSections,
        );

        return values;
      }
      default:
        return intermediateEvaluation;
    }
  };
  const [intermediateEvaluation, dispatchReducer] = React.useReducer(
    reducer,
    getInitialValue(review, scorecardStepSections, subjectiveSections),
  );

  React.useEffect(() => {
    dispatchReducer({type: 'RESET_INTERMEDIATE_EVALUATION'});
  }, [onBehalfOfUserId, stepCandidateId, review]);

  const {hideScorecard, hideOverallRecommendation, stepType} = step;
  const {hasNote, minFeedbackWords} = feedbackConfiguration || {};

  const formValueToPayloadValue = () => {
    const {feedbackScores, answers, reviewStatus, comment} =
      intermediateEvaluation || {};

    const htmlComment = convertDraftToHTML(comment);

    const finalEvaluation = {
      feedbackScores,
      answers,
      reviewStatus,
      comment: htmlComment,
    } as const;

    // overall recommendation validation
    if (!hideOverallRecommendation) {
      if (!reviewStatus) {
        toastApi.show(
          <Toast semantic={TOAST_SEMANTIC.danger}>
            <ToastTitle>
              {`${t(
                'Overall_recommendation_section_is_incomplete',
                'Overall recommendation section is incomplete',
              )}`}
            </ToastTitle>
          </Toast>,
        );
        return;
      }
      const commentWords = getTextFromHtml(htmlComment);

      const commentLength = commentWords
        ? commentWords.split(' ').filter((w) => w !== '').length
        : 0;
      if (hasNote && commentLength < minFeedbackWords) {
        toastApi.show(
          <Toast semantic={TOAST_SEMANTIC.danger}>
            <ToastTitle>
              {`${t(
                'Minimum_word_limit_Overall_Comment_is',
                'Minimum word limit Overall Comment is',
              )} ${minFeedbackWords}`}
            </ToastTitle>
          </Toast>,
        );
        return;
      }
      // @ts-expect-error - TS2367 - This comparison appears to be unintentional because the types 'string' and 'EditorState' have no overlap.
      if (htmlComment === EditorState.createEmpty()) {
        toastApi.show(
          <Toast semantic={TOAST_SEMANTIC.danger}>
            <ToastTitle>
              {`${t(
                'Minimum_word_limit_is',
                'Minimum word limit is',
              )} ${minFeedbackWords}`}
            </ToastTitle>
          </Toast>,
        );
      }
    }

    // scorecard validation
    if (!hideScorecard) {
      // @ts-expect-error - TS2347 - Untyped function calls may not accept type arguments.
      const mandatoryParameterIds = scorecardStepSections
        // @ts-expect-error - TS7006 - Parameter 'section' implicitly has an 'any' type.
        .filter((section) => section.status === 'MANDATORY')
        // @ts-expect-error - TS7006 - Parameter 'acc' implicitly has an 'any' type. | TS7006 - Parameter 'section' implicitly has an 'any' type.
        .reduce<Array<any>>((acc, section) => {
          const parameterIds = section.parameters.map(
            // @ts-expect-error - TS7006 - Parameter 'parameter' implicitly has an 'any' type.
            (parameter) => parameter.id,
          );
          acc.push(...parameterIds);
          return acc;
        }, []);

      const isIncomplete = !!mandatoryParameterIds.find(
        // @ts-expect-error - TS7006 - Parameter 'mandatoryParameterId' implicitly has an 'any' type.
        (mandatoryParameterId) => {
          const foundParameter = finalEvaluation.feedbackScores.find(
            // @ts-expect-error - TS7006 - Parameter 'score' implicitly has an 'any' type.
            (score) =>
              score.parameterId === mandatoryParameterId && !score.score,
          );
          return foundParameter;
        },
      );

      if (isIncomplete) {
        toastApi.show(
          <Toast semantic={TOAST_SEMANTIC.danger}>
            <ToastTitle>
              {`${t(
                'Scorecard_section_parameters_are_mandatory',
                'Scorecard section parameters are mandatory',
              )}`}
            </ToastTitle>
          </Toast>,
        );
        return;
      }
    }

    // subjective questions validation
    // @ts-expect-error - TS7006 - Parameter 'question' implicitly has an 'any' type.
    const unansweredMandatoryQuestions = questions.filter((question) => {
      if (
        question.required &&
        question.fieldType === 'TEXT_AREA' &&
        finalEvaluation.answers[question.id] === ''
      ) {
        return true;
      }

      if (
        question.required &&
        question.fieldType === 'NUMBER' &&
        finalEvaluation.answers[question.id] >= 0
      ) {
        return false;
      }
      if (question.required && !finalEvaluation.answers[question.id]) {
        return true;
      }
      return false;
    });

    if (unansweredMandatoryQuestions.length > 0) {
      setErrorQuestionIds(
        // @ts-expect-error - TS7006 - Parameter 'question' implicitly has an 'any' type.
        unansweredMandatoryQuestions.map((question) => question.id),
      );
      toastApi.show(
        <Toast semantic={TOAST_SEMANTIC.danger}>
          <ToastTitle>{`${t(
            'Please_answer_the_required_questions',
            'Please answer the required questions',
          )}`}</ToastTitle>
        </Toast>,
      );
      return;
    }

    const formattedEvaluation = {
      ...finalEvaluation,

      answers: questions
        // @ts-expect-error - TS7006 - Parameter 'q' implicitly has an 'any' type.
        .filter((q) => finalEvaluation.answers[q.id] !== undefined)
        // @ts-expect-error - TS7006 - Parameter 'q' implicitly has an 'any' type.
        .map((q) => {
          return {
            questionId: q.id,
            answer:
              q.fieldType === 'TEXT_AREA'
                ? convertDraftToHTML(finalEvaluation.answers[q.id])
                : finalEvaluation.answers[q.id],
          };
        }),
    } as const;

    onSubmit(formattedEvaluation);
  };

  const {feedbackScores, answers, reviewStatus, comment} =
    intermediateEvaluation || {};

  return (
    <>
      <PanelBody
        className={classify(css.panelBody, {
          [css.panelBodyWithoutPadding]: alreadyInPanelBody,
        })}
      >
        {!hideScorecard && (
          <EvaluationScorecardEdit
            scorecardStepSections={scorecardStepSections}
            feedbackScores={feedbackScores}
            feedbackConfiguration={feedbackConfiguration}
            // @ts-expect-error - TS2322 - Type '{ scorecardStepSections: any; feedbackScores: any; feedbackConfiguration: any; stepId: any; handleScorecardOnChange: ({ parameterId, score }: { parameterId: any; score: any; }) => void; handleRemarkChange: (parameterId: any, remark: any) => void; }' is not assignable to type 'IntrinsicAttributes & { scorecardStepSections: any; feedbackScores: any; feedbackConfiguration: any; handleScorecardOnChange: any; handleRemarkChange: any; }'.
            stepId={step.id}
            // @ts-expect-error - TS7031 - Binding element 'parameterId' implicitly has an 'any' type. | TS7031 - Binding element 'score' implicitly has an 'any' type.
            handleScorecardOnChange={({parameterId, score}) =>
              dispatchReducer({
                type: 'SCORECARD_PARAMETER',
                parameterId,
                score,
              })
            }
            // @ts-expect-error - TS7006 - Parameter 'parameterId' implicitly has an 'any' type. | TS7006 - Parameter 'remark' implicitly has an 'any' type.
            handleRemarkChange={(parameterId, remark) => {
              dispatchReducer({type: 'SCORECARD_REMARK', parameterId, remark});
            }}
          />
        )}
        <EvaluationSubjectiveQuestionsEdit
          answers={answers}
          subjectiveSections={subjectiveSections}
          // @ts-expect-error - TS7006 - Parameter 'id' implicitly has an 'any' type. | TS7006 - Parameter 'value' implicitly has an 'any' type.
          onChange={(id, value) =>
            dispatchReducer({
              type: 'SUBJECTIVE_ANSWERS',
              questionId: id,
              answer: value,
            })
          }
          token={token}
          tokenId={tokenId}
          errorQuestionIds={errorQuestionIds}
          setErrorQuestionIds={setErrorQuestionIds}
        />
        {!hideOverallRecommendation && (
          <EvaluationRecommendationEdit
            reviewStatus={reviewStatus}
            stepType={stepType}
            comment={comment}
            feedbackConfiguration={feedbackConfiguration}
            onReviewStatusChange={(reviewStatus) =>
              dispatchReducer({type: 'OVERALL_STATUS', reviewStatus})
            }
            onCommentChange={(value) =>
              dispatchReducer({type: 'OVERALL_COMMENT', comment: value})
            }
          />
        )}
      </PanelBody>
      <PanelFooter
        classNames={{
          wrapper: classify(css.panelFooter, {
            [css.panelFooterWithoutPadding]: alreadyInPanelBody,
          }),
        }}
      >
        <Button onClick={onCancel} type="tertiary">
          {t('Cancel', 'Cancel')}
        </Button>
        <Button onClick={formValueToPayloadValue} isLoading={isSubmitting}>
          {t('Submit', 'Submit')}
        </Button>
      </PanelFooter>
    </>
  );
};

export default EvaluationFormEdit;
